export default "__VITE_ASSET__845dbce1__"